// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"AutoMatchModaleList_termsContainer__3iW1Z","terms":"AutoMatchModaleList_terms__xMmA-","term":"AutoMatchModaleList_term__1Lvkg"};